<template>
<ItpBox>
  <ItpSidebar
    default-width="400"
    scroll-y
    class="mr-2"
  >
    <UcInvoiceGeneratorControls
      ref="panel"
    >
    </UcInvoiceGeneratorControls>
  </ItpSidebar>
  <DIV
    class="h-100 w-100 overflow-hidden position-relative"
  >
    <VueSlickgrid
      :name="gridName"
      :resizeTrigger="resizeTrigger"
      :headerTitle="'Draft Invoices'|gettext"
      :items="ds"
      checkbox-row-selection
      footer-totals
      export-to-csv
      :exportToCsvFilename="'draft-invoices'|pgettext('ExportFilename')"
      :columnDefaults="b_1040167445267876_columnDefaults"
      :columns="b_1040167445267876_columns"
      class="page--grid"
      ref="grid"
      @selectedRowsChanged="evh_1040167445267876_selectedRowsChanged($event, {})"
      @command="evh_1040167445267876_command($event, {})"
    >
      <DIV
        class="flex-grow-1 d-flex"
        slot="toolbar"
      >
        <ItpButton
          :icon="$config.billingList.createItemIcon"
          :text="'Bulk edit...'|pgettext('Invoices')"
          size="sm"
          variant="light"
          :disabled="!selectedItems || !selectedItems.length"
          @click="evh_7789867021953041_click($event, {})"
        >
        </ItpButton>
        <ItpButton
          :icon="$config.mergeIcon"
          :text="'Merge invoices'|gettext"
          size="sm"
          variant="light"
          :disabled="!selectedItems || !selectedItems.length"
          :spinning="actions.mergeInvoices.isRunning"
          class="mx-2"
          @click="evh_3468003412020058_click($event, {})"
        >
        </ItpButton>
        <ItpButton
          icon="fa-trash"
          :text="'Delete'|gettext"
          size="sm"
          variant="light"
          :disabled="!selectedItems || !selectedItems.length"
          :spinning="actions.deleteItems.isRunning"
          class="mx-2"
          @click="evh_4834182479726849_click($event, {})"
        >
        </ItpButton>
        <JobHandlerControl
          jobType="invoice_sync"
          load-current
          :payload="() => onIssueInvoicesPayload()"
          icon="material-symbols:cloud-sync-outline-rounded"
          :text="'Issue Invoices'|pgettext('DraftInvoices|Submit')"
          size="sm"
          :disabled="!selectedItems || !selectedItems.length"
        >
        </JobHandlerControl>
        <ItpLink
          :text="'Download invoice lines'|pgettext('InvoiceGeneration')"
          :href="$fn.urlFor('draft_invoice_lines_report')"
          button
          variant="light"
          use-auth
          timeout="300000"
          class="d-inline-block mx-2"
        >
        </ItpLink>
        <ArtifactJob
          icon="ic:baseline-download"
          :text="'Download views'|gettext"
          size="sm"
          :disabled="!selectedItems || !selectedItems.length"
          operation="download_invoice_views"
          :payload="boundDownloadViewsPayloadMethod()"
          class="ml-2"
        >
        </ArtifactJob>
      </DIV>
    </VueSlickgrid>
  </DIV>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceGenerationInvoices extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };
  sse = {
    cleanup: true,
  };

  beforeCreate() {
  }

  processMessage(...args: any[]) {
    const msg = args[0];
    if (msg.event === 'InvoiceGeneratorStatus') {
      this.$refs.panel.updateStatus(msg.data);
    }
    if (msg.event === 'InvoiceCreated') {
      this.$refs.grid.dataView.addItem(msg.data);
    }
    if (msg.event === 'InvoiceUpdated') {
      this.$refs.grid.dataView.updateItem(msg.data.id, msg.data);
    }
    if (msg.event === 'InvoiceDeleted') {
      this.$refs.grid.dataView.removeItem(msg.data.id);
    }
  }

  onIssueInvoicesPayload(...args: any[]) {
    return this.$imodal
      .show({ name: 'CompleteInvoicesAlt' })
      .then(result => {
        if (!result || result.cancel || !result.value) {
          return;
        }
        return this.selectedItems.map(p => ({
          ...result.value,
          invoice_id: p.id,
        }));
      }
      )
  }

  getDownloadViewsPayload(...args: any[]) {
    return {
      identities: _.chain(this.selectedItems)
        .map(p => p.id)
        .uniq()
        .value()
    }
  }

  boundDownloadViewsPayloadMethod(...args: any[]) {
    if (!this._getDownloadViewsPayload) {
      this._getDownloadViewsPayload = this.getDownloadViewsPayload.bind(this);
    }
    return this._getDownloadViewsPayload
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  gridName!: any;
  resizeTrigger!: any;
  selectedItems!: any;
  ts!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_draft_invoices')
  }

  ux!: any;
  b_1040167445267876_columnDefaults!: any;
  b_1040167445267876_columns!: any;
  dataMembers = ['gridName', 'resizeTrigger', 'selectedItems', 'ts', 'ds', 'ux', 'b_1040167445267876_columnDefaults', 'b_1040167445267876_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        gridName: "draftInvoices",
        resizeTrigger: 0,
        selectedItems: [
        ]
        ,
        ts: null,
        ds: null,
        ux: null,
        b_1040167445267876_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_1040167445267876_columns: [{
          field: "invoice",
          name: this.$fn.pgettext("BillingList", "Invoice"),
          params: {
            sortPath: "invoice.invoice_number",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <a href=\"#\" onclick=\"return false;\">\n\
      <strong title=\"{{ $value.invoice_number }}\">{{ $value.invoice_number }}</strong>\n\
    </a>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "company",
          name: this.$fn.pgettext("BillingList", "Company"),
          width: "100px",
          params: {
            sortPath: "company.code",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "company.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "partner",
          name: this.$fn.pgettext("BillingList", "Partner"),
          width: "100px",
          params: {
            sortPath: "partner.code",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "partner.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "rentals",
          name: this.$fn.pgettext("InvoicesView", "Rentals"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            separator: ", ",
            formatterContext: "value",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "name",
                source: "value",
              }
              ,
            }
              ,
            {
              name: "routeLink",
              to: "rental",
              navigateOnIconClick: true,
              params: {
                id: "id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "contracts",
          name: this.$fn.pgettext("InvoicesView", "Contracts"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            separator: ", ",
            formatterContext: "value",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "contract_number",
                source: "value",
              }
              ,
            }
              ,
            {
              name: "routeLink",
              to: "contract",
              navigateOnIconClick: true,
              params: {
                id: "id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          name: this.$fn.pgettext("Invoices", "Period start"),
          params: {
            sortPath: "billing_period.start",
          }
          ,
          field: "billing_period.start",
          type: "date",
          formatter: [{
            name: "getvalue",
            opts: {
              field: "billing_period.start",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          name: this.$fn.pgettext("Invoices", "Period end"),
          params: {
            sortPath: "billing_period.end",
          }
          ,
          field: "billing_period.end",
          type: "date",
          formatter: [{
            name: "getvalue",
            opts: {
              field: "billing_period.end",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "billing_category",
          name: this.$fn.pgettext("InvoiceBrowserView", "Billing category"),
        }
          ,
        {
          field: "net_amount",
          name: this.$fn.pgettext("InvoiceBrowserView", "Net"),
          type: "number",
          formatter: {
            name: "number",
          }
          ,
        }
          ,
        {
          field: "vat_amount",
          name: this.$fn.pgettext("InvoiceBrowserView", "VAT"),
          type: "number",
          formatter: {
            name: "number",
          }
          ,
        }
          ,
        {
          field: "amount",
          name: this.$fn.pgettext("InvoiceBrowserView", "Amount"),
          type: "number",
          formatter: {
            name: "number",
          }
          ,
        }
          ,
        {
          field: "currency",
          name: this.$fn.pgettext("InvoiceBrowserView", "Currency"),
        }
          ,
        {
          field: "invoice_date",
          name: this.$fn.pgettext("InvoiceBrowserView", "Invoice date"),
          type: "date",
        }
          ,
        {
          field: "fulfillment_date",
          name: this.$fn.pgettext("InvoiceBrowserView", "Fulfillment date"),
          type: "date",
        }
          ,
        {
          field: "due_date",
          name: this.$fn.pgettext("InvoiceBrowserView", "Due date"),
          type: "date",
        }
          ,
        {
          field: "accounting_date",
          name: this.$fn.pgettext("InvoiceBrowserView", "Accounting date"),
          type: "date",
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return
    }
    return null;
  }

  async act_1040167445267876_setData_7396_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_7396, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_1040167445267876_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_showModal_7398_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_1040167445267876_showModal_7398, alias=undefined
    return {
      name: "Invoice",
      props: {
        oid: $event.data.data.id,
        modal: true,
      }
      ,
    }
  }

  async evh_1040167445267876_command_7397_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_command_7397, alias=undefined
    return $event.data.column.id === 'invoice'
  }

  async evh_1040167445267876_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_command.executeFromDOM(this, event, scope);
  }

  async act_7789867021953041_reloadSlickgrid_7402_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_7789867021953041_reloadSlickgrid_7402, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_7789867021953041_close_7401_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7789867021953041_close_7401, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_7789867021953041_showModal_7400_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7789867021953041_showModal_7400, alias=undefined
    return {
      name: "BatchInvoiceEditor",
      props: {
        invoices: this.selectedItems,
      }
      ,
    }
  }

  async evh_7789867021953041_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7789867021953041_click.executeFromDOM(this, event, scope);
  }

  async act_3468003412020058_reloadSlickgrid_7406_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_3468003412020058_reloadSlickgrid_7406, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async act_3468003412020058_request_7404_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_3468003412020058_request_7404, alias=mergeInvoices
    return {
      operation: "merge_invoices",
      data: {
        items: _.chain(this.selectedItems)
          .filter(p => _.get(p, 'id') != null)
          .map(p => p.id)
          .uniq()
          .value()
      },
    }
  }

  async evh_3468003412020058_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3468003412020058_click.executeFromDOM(this, event, scope);
  }

  async act_4834182479726849_reloadSlickgrid_7410_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4834182479726849_reloadSlickgrid_7410, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async act_4834182479726849_request_7408_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_4834182479726849_request_7408, alias=deleteItems
    return {
      operation: "delete_draft_invoices",
      data: {
        invoices: this.selectedItems.map(p => p.id)
      },
    }
  }

  async evh_4834182479726849_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4834182479726849_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1040167445267876_setData_7396: actions.SetDataAction;
    evh_1040167445267876_selectedRowsChanged_7395: actions.EventHandlerImpl;
    evh_1040167445267876_selectedRowsChanged: actions.EventHandlerGroup;
    act_1040167445267876_showModal_7398: actions.ShowModalAction;
    evh_1040167445267876_command_7397: actions.EventHandlerImpl;
    evh_1040167445267876_command: actions.EventHandlerGroup;
    act_7789867021953041_reloadSlickgrid_7402: actions.ReloadSlickgridAction;
    evh_7789867021953041_close_7401: actions.EventHandlerImpl;
    act_7789867021953041_showModal_7400: actions.ShowModalAction;
    evh_7789867021953041_click_7399: actions.EventHandlerImpl;
    evh_7789867021953041_click: actions.EventHandlerGroup;
    act_3468003412020058_reloadSlickgrid_7406: actions.ReloadSlickgridAction;
    evh_3468003412020058_success_7405: actions.EventHandlerImpl;
    act_3468003412020058_request_7404: actions.RequestAction;
    evh_3468003412020058_click_7403: actions.EventHandlerImpl;
    evh_3468003412020058_click: actions.EventHandlerGroup;
    act_4834182479726849_reloadSlickgrid_7410: actions.ReloadSlickgridAction;
    evh_4834182479726849_success_7409: actions.EventHandlerImpl;
    act_4834182479726849_request_7408: actions.RequestAction;
    evh_4834182479726849_click_7407: actions.EventHandlerImpl;
    evh_4834182479726849_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1040167445267876_setData_7396 = new actions.SetDataAction(
      {
        actionArgs: this.act_1040167445267876_setData_7396_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_selectedRowsChanged_7395 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_setData_7396,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_1040167445267876_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_selectedRowsChanged_7395],
      }
    );
    const act_1040167445267876_showModal_7398 = new actions.ShowModalAction(
      {
        actionArgs: this.act_1040167445267876_showModal_7398_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_command_7397 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_showModal_7398,
        event: "command",
        when: this.evh_1040167445267876_command_7397_getWhen,
        displayName: "showModal",
      }
    );
    const evh_1040167445267876_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_command_7397],
      }
    );
    const act_7789867021953041_reloadSlickgrid_7402 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_7789867021953041_reloadSlickgrid_7402_getActionArgs,
        events: [],
      }
    );
    const evh_7789867021953041_close_7401 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_reloadSlickgrid_7402,
        event: "close",
        when: this.evh_7789867021953041_close_7401_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_7789867021953041_showModal_7400 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7789867021953041_showModal_7400_getActionArgs,
        events: [evh_7789867021953041_close_7401],
      }
    );
    const evh_7789867021953041_click_7399 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_showModal_7400,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_7789867021953041_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_7789867021953041_click_7399],
      }
    );
    const act_3468003412020058_reloadSlickgrid_7406 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_3468003412020058_reloadSlickgrid_7406_getActionArgs,
        events: [],
      }
    );
    const evh_3468003412020058_success_7405 = new actions.EventHandlerImpl(
      {
        action: act_3468003412020058_reloadSlickgrid_7406,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_3468003412020058_request_7404 = new actions.RequestAction(
      {
        actionArgs: this.act_3468003412020058_request_7404_getActionArgs,
        displayName: "mergeInvoices",
        events: [evh_3468003412020058_success_7405],
      }
    );
    const evh_3468003412020058_click_7403 = new actions.EventHandlerImpl(
      {
        action: act_3468003412020058_request_7404,
        event: "click",
        displayName: "mergeInvoices",
      }
    );
    const evh_3468003412020058_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_3468003412020058_click_7403],
      }
    );
    const act_4834182479726849_reloadSlickgrid_7410 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4834182479726849_reloadSlickgrid_7410_getActionArgs,
        events: [],
      }
    );
    const evh_4834182479726849_success_7409 = new actions.EventHandlerImpl(
      {
        action: act_4834182479726849_reloadSlickgrid_7410,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_4834182479726849_request_7408 = new actions.RequestAction(
      {
        actionArgs: this.act_4834182479726849_request_7408_getActionArgs,
        displayName: "deleteItems",
        events: [evh_4834182479726849_success_7409],
      }
    );
    const evh_4834182479726849_click_7407 = new actions.EventHandlerImpl(
      {
        action: act_4834182479726849_request_7408,
        event: "click",
        displayName: "deleteItems",
      }
    );
    const evh_4834182479726849_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4834182479726849_click_7407],
      }
    );
    return {
      act_1040167445267876_setData_7396,
      evh_1040167445267876_selectedRowsChanged_7395,
      evh_1040167445267876_selectedRowsChanged,
      act_1040167445267876_showModal_7398,
      evh_1040167445267876_command_7397,
      evh_1040167445267876_command,
      act_7789867021953041_reloadSlickgrid_7402,
      evh_7789867021953041_close_7401,
      act_7789867021953041_showModal_7400,
      evh_7789867021953041_click_7399,
      evh_7789867021953041_click,
      act_3468003412020058_reloadSlickgrid_7406,
      evh_3468003412020058_success_7405,
      act_3468003412020058_request_7404,
      evh_3468003412020058_click_7403,
      evh_3468003412020058_click,
      act_4834182479726849_reloadSlickgrid_7410,
      evh_4834182479726849_success_7409,
      act_4834182479726849_request_7408,
      evh_4834182479726849_click_7407,
      evh_4834182479726849_click,
      mergeInvoices: act_3468003412020058_request_7404,
      deleteItems: act_4834182479726849_request_7408,
    }
  }
}

Vue.component("UcInvoiceGenerationInvoices", UcInvoiceGenerationInvoices);

</script>